{
  "accountScreen": {
    "downloadCta": "Download Signed Document",
    "helpDescription": "Email us at <underline>{{email}}</underline>",
    "helpTitle": "Need Help or Have Questions?",
    "loggedInWith": "Logged in with {{method}}",
    "title": "Account",
    "usernameLoginMethod": "Username"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Add Another",
    "addingMemberDescription": "We want to know who all your household members are.",
    "addingMemberTitle": "Tell us about them",
    "age": "Age",
    "coverageCheck": {
      "dateOfBirth": "Date of birth (optional)",
      "description": "Optional. This helps us find coverage they may already have.",
      "medicaidId": "Medicaid ID (optional)",
      "medicaidIdPlaceholder": "Enter Medicaid ID",
      "ssn": "SSN (optional)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Help us check their coverage"
    },
    "duplicateDialog": {
      "cancel": "No, go back",
      "checkError": "We couldn’t check your household members. Please try again.",
      "confirm": "Yes, different person",
      "description": "You’ve already added <bold>{{name}}</bold>. Is the person you’re adding now someone different?",
      "descriptionWithDetails": "You’ve already added <bold>{{name}}</bold> ({{details}}). Is the person you’re adding now someone different?",
      "reminder": "There’s no need to add anyone you’ve already added.",
      "title": "Is this someone new?"
    },
    "enterDateOfBirth": "Enter date of birth instead",
    "enterRelationship": "Enter relationship",
    "firstName": "First Name",
    "formSubmission": {
      "error": "We couldn't add that household member. Please try again.",
      "success": "{{firstName}} added successfully"
    },
    "lastName": "Last Name",
    "livingWithMe": "Living with me",
    "relationshipToMe": "Relationship to me",
    "sameMailingAddress": "Same mailing address",
    "updateFormSubmission": {
      "success": "{{firstName}} updated successfully"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Please enter either an age range or a date of birth.",
      "futureDateOfBirth": "Please enter a date of birth on or before today.",
      "invalidDateOfBirth": "Please enter a valid date of birth (MM/DD/YYYY).",
      "selectAnOption": "Please select an option.",
      "specifyRelationship": "Please describe this person's relationship to you."
    }
  },
  "appFooter": {
    "partnershipLabel": "In Partnership with"
  },
  "appHeader": {
    "toggleThemeTooltip": "Theme Toggle is temporary to easily debug switching dark/white mode. Only renders on local and DEV environments."
  },
  "appMenu": {
    "account": "Account",
    "household": "Household",
    "language": "Language",
    "logout": "Logout"
  },
  "applicantDocuments": {
    "alsoCompleted": "This document also completed {{section}}.",
    "alsoCompletedResidenceForMembers": "This document also completed {{section}} for household members who live at the same address",
    "deleteDialog": {
      "description": "Are you sure you want to delete this document? This action cannot be undone.",
      "title": "Delete Document"
    },
    "deleteToast": {
      "error": "We couldn't delete that document. Please try again.",
      "success": "Document deleted successfully"
    },
    "immigrationIncomplete": {
      "description": "You still need to upload a USCIS ID, immigration documents/approvals, or an I-20 to complete {{section}}.",
      "dismiss": "Got it",
      "title": "One more document needed"
    },
    "optional": "Optional",
    "progress": "{{completeCount}} of {{applicableCount}} complete",
    "selectDocumentType": "Select Document Type",
    "ssn": {
      "cardOption": "Or upload your Social Security card",
      "label": "Social Security Number",
      "save": "Save",
      "saveError": "We couldn't save that number. Please try again.",
      "saved": "Social Security Number saved"
    },
    "supportedFiles": "Supported file types: PDF, JPG, PNG",
    "upload": {
      "failed": "This document couldn't be uploaded. Please try again.",
      "failedDescription": "We couldn't read this file. Please remove it and upload a new copy.",
      "uploading": "Uploading..."
    },
    "uploadOne": "Upload <bold>at least one:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Please review and confirm home and mailing addresses for all household members.",
    "homeAddress": "Home Address",
    "isHomeless": "No Home Address",
    "mailingAddress": "Mailing Address",
    "needsHomeAddress": "<italic>Needs Home Address</italic>",
    "needsMailingAddress": "<italic>Needs Mailing Address</italic>",
    "noMailingAddress": "No Mailing Address",
    "sameHomeAddress": "Same home address",
    "sameMailingAddress": "Same mailing address",
    "title": "Address Information",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "home address",
      "addressTypeHomeAndMailing": "home and mailing address",
      "addressTypeMailing": "mailing address",
      "description_one": "{{householdName}} and {{count}} other currently share your {{addressType}}. Would you like to update theirs as well?",
      "description_other": "{{householdName}} and {{count}} others currently share your {{addressType}}. Would you like to update theirs as well?",
      "description_zero": "{{householdName}} currently shares your {{addressType}}. Would you like to update theirs as well?",
      "onlyUpdateMine": "No, only update mine",
      "title": "Update household addresses",
      "updateMembers_one": "Update {{count}} member",
      "updateMembers_other": "Update {{count}} members"
    },
    "you": "{{name}} (You)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "The children must <bold>live with the household member</bold> for <bold>more than half the year</bold> and the household member must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills). This includes non-blood relatives.",
    "title": "Do the following household members live with and care for any children under the age of 19?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "Are <bold>{{householdMembersNames}}</bold> all U.S. Citizens?",
    "hintDescription": "If you select <bold>No</bold>, don't worry. There are other options available for program eligibility based on immigration status.",
    "noDescription": "Some or all are not U.S. Citizens",
    "title": "Application Eligibility",
    "yesDescription": "Everyone listed is a U.S. Citizen"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Select “Yes, connect me” to get help staying with your doctors and covering your family in one place.",
      "summaryWithMedicaid": "We'll review your Medicaid application and reach out if we need anything. You'll still need a licensed insurance agent to finish enrolling in {{programs}}.",
      "summaryWithoutMedicaid": "We have what you submitted. You'll still need a licensed insurance agent to finish enrolling in {{programs}}.",
      "title": "You chose not to connect with a licensed insurance agent. Are you sure?"
    },
    "continueButton": "Continue",
    "description": "Our team will review your applications and reach out if we need anything. Once everything looks good, we’ll send it to the programs you chose.",
    "title": "We got your applications!"
  },
  "applicationCoverageStatusScreen": {
    "description": "Do <bold>{{householdMembersNames}}</bold> have health insurance or coverage? Include coverage starting soon.",
    "noDescription": "No one has coverage",
    "pleaseSpecify": "Please specify",
    "title": "Coverage Statuses",
    "whatType": "What type of coverage?",
    "who": "Who has coverage?",
    "yesDescription": "Someone has coverage"
  },
  "applicationDateOfBirthScreen": {
    "description": "Please add and confirm for all household members",
    "success": "All dates of birth have been saved",
    "title": "Date of Birth"
  },
  "applicationDocuments": {
    "description": "We’ll use these documents to confirm the details in your application. You can upload files now or come back to finish later.",
    "title": "Upload Documents"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Add Another Expense",
    "addExpense": "Add Expense",
    "description": "Add deductible and medical expenses for each household member.",
    "expenseTypes": {
      "ALIMONY_PAID": "Alimony Paid",
      "CHILDCARE": "Childcare",
      "IRA_CONTRIBUTIONS": "IRA Contributions",
      "MEDICAL_EXPENSES": "Medical Expenses",
      "MOVING_EXPENSES": "Moving Expenses",
      "NONE": "None",
      "OTHER": "Other",
      "STUDENT_LOANS": "Student Loans",
      "TUITION_FEES": "Tuition Fees"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "We'll ask you to upload proof of this expense later, so have the relevant documents ready. This could include medical bills or receipts from providers or pharmacies.",
        "OTHER": "We'll ask you to upload proof of this expense later, so have the relevant documents ready.",
        "STUDENT_LOANS": "We'll ask you to upload proof of this expense later, so have the relevant documents ready. This could include student loan statements or award letters from your school."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "Do you have medical expenses in the last 3 months that you need help paying for?",
      "title": "Select an Expense"
    },
    "monthlyExpense": "{{monthlyExpense}} / month",
    "progress": "Progress: {{progress}} of {{total}} complete",
    "title": "Household Expenses"
  },
  "applicationFlow": {
    "amountPerMonth": "Amount per month"
  },
  "applicationForm": {
    "applyingToCounter": "Applying to {{programsCount}} for {{householdMembersCount}}",
    "continueButton": "Continue to Applications",
    "greatNews": "Great News!",
    "letsCreateApplications": "Let’s create applications for everyone.",
    "mayBeEligible": "<bold>{{names}}</bold> may be eligible",
    "mayBeEligibleFor": "{{memberNames}} may be eligible for <bold>{{brand}}</bold>",
    "notEligible": "Not eligible at this time",
    "programConflictDialog": {
      "description": "Applying to {{newProgram}} will remove {{memberNames}}’s application for {{currentPrograms}}. {{memberNames}} can’t apply for both at the same time. When you submit, we’ll make sure {{memberNames}} is in the right program.",
      "description_members": "Applying to {{newProgram}} will remove the {{currentPrograms}} applications for {{memberNames}}. {{memberNames}} can’t apply for both at the same time. When you submit, we’ll make sure {{memberNames}} are in the right program.",
      "description_self": "Applying to {{newProgram}} will remove your application for {{currentPrograms}}. You can’t apply for both at the same time. When you submit, we’ll make sure you’re in the right program.",
      "keepButton": "Keep {{currentPrograms}}",
      "multipleDescription": "Applying to {{newProgram}} will remove {{memberNames}}’s applications for {{currentPrograms}}. {{memberNames}} can’t apply for all of them at the same time. When you submit, we’ll make sure {{memberNames}} is in the right program.",
      "multipleDescription_members": "Applying to {{newProgram}} will remove the {{currentPrograms}} applications for {{memberNames}}. {{memberNames}} can’t apply for all of them at the same time. When you submit, we’ll make sure {{memberNames}} are in the right program.",
      "multipleDescription_self": "Applying to {{newProgram}} will remove your applications for {{currentPrograms}}. You can’t apply for all of them at the same time. When you submit, we’ll make sure you’re in the right program.",
      "recommendMedicaidDescription": "{{memberNames}} can’t apply for both at the same time. Medicaid is free, and {{memberNames}} qualifies for it. When you submit, we’ll make sure {{memberNames}} is in the right program.",
      "recommendMedicaidDescription_members": "{{memberNames}} can’t apply for both at the same time. Medicaid is free, and {{memberNames}} qualify for it. When you submit, we’ll make sure {{memberNames}} are in the right program.",
      "recommendMedicaidDescription_self": "You can’t apply for both at the same time. Medicaid is free, and you qualify for it. When you submit, we’ll make sure you’re in the right program.",
      "recommendMedicaidTitle": "We recommend applying for Medicaid",
      "switchButton": "Switch to {{newProgram}}",
      "title": "You can only apply for one program"
    },
    "programsFound": "We found {{programsCount}} eligible programs for all {{householdMembersCount}} household members.",
    "recentDuplicateDialog": {
      "continueAnyway": "Continue Anyway",
      "description": "You recently submitted a <bold>{{applicationType}}</bold> application for {{memberNames}}. You should only submit another application if something has changed.",
      "multipleDescription": "You recently submitted <bold>{{applicationTypes}}</bold> applications for {{memberNames}}. You should only submit another application if something has changed.",
      "title": "You recently submitted an application"
    },
    "startButton": "Start Applications"
  },
  "applicationMaritalStatusScreen": {
    "description": "We've set marital statuses based on your household relationships. Please review and update if needed.",
    "needsMaritalStatus": "Needs marital status",
    "title": "Current Marital Statuses"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "American Indian or Alaska Native",
      "needsHelpDailyActivities": "Needs help with daily activities",
      "studentFullTime18to20": "Full-time student (ages 18 - 20)",
      "veteranOrMilitaryMember": "Veteran or military member"
    },
    "description": "Please select any situations that apply to household members.",
    "errors": {
      "unableToUpdateHouseholdMembers": "We couldn't save those changes. Please try again."
    },
    "title": "Other Statuses"
  },
  "applicationSection": {
    "applications": "Applications",
    "beginYourApplicationCompact": "Apply in 15 min or less",
    "beginYourApplicationProcess": "Begin the application process and get covered in 15min or less",
    "continueQuickApply": "Continue Quick Apply",
    "continueYourApplicationCompact": "Continue your application",
    "continueYourApplicationProcess": "Continue the application process and get covered in 15min or less",
    "newQuickApply": "New Quick Apply",
    "quickApply": "Quick Apply"
  },
  "applicationSubmitScreen": {
    "description": "You’ve completed all the steps. When you’re ready, submit below.",
    "hintMessage": "You can’t make changes after submission, so please be sure everything is correct.",
    "partialFailure": "Some of your applications may not have been submitted. Please review them in your applications list.",
    "submitButton": "Submit Applications",
    "success": "Applications submitted successfully.",
    "title": "You’re All Set!"
  },
  "applicationTaxInformationScreen": {
    "description": "Based on the information you shared about your household, we believe this reflects everyone’s tax status. Please review and update if needed.",
    "errors": {
      "unableToUpdateRelationship": "We couldn't update that relationship. Please try again."
    },
    "memberCard": {
      "dependentOf": "Dependent of: {{name}}",
      "dependents": "Dependents: {{name}}",
      "memberDialog": {
        "description": "Review and update this person’s tax details if needed.",
        "saveAndReturn": "Save and Return",
        "taxClaimedAsDependentStatus": "Will anyone claim this person as a dependent?",
        "taxDependentsClaimedStatus": "Will this person claim any dependents?",
        "taxFilingStatus": "Tax Status",
        "title": "Tax Information – {{name}}",
        "who": "Who?"
      }
    },
    "needsTaxInformation": "Needs tax information",
    "success": "Tax information updated successfully",
    "title": "Tax Information"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Add Another Income",
    "addIncome": "Add Income",
    "description": "Add work and income information for each household member.",
    "incomeTypes": {
      "ALIMONY": "Alimony",
      "EMPLOYED": "Employed",
      "NONE": "None",
      "OTHER": "Other",
      "PENSION": "Pension",
      "PROPERTY_RENTAL_INCOME": "Property rental income",
      "RETIREMENT_INCOME": "Retirement income",
      "SELF_EMPLOYED": "Self-employed",
      "SSA": "SSA",
      "SSDI": "SSDI",
      "UNEMPLOYED": "Unemployed",
      "WORKERS_COMPENSATION": "Worker's compensation"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "We'll ask you to upload proof of this income later, so have the relevant documents ready. This could include paystubs or W-2 forms.",
        "OTHER": "We'll ask you to upload proof of this income later, so have the relevant documents ready. This could include award letters or benefit statements.",
        "SELF_EMPLOYED": "We'll ask you to upload proof of this income later, so have the relevant documents ready. This could include invoices or 1099 forms.",
        "UNEMPLOYED": "We'll ask you to upload proof of this income later, so have the relevant documents ready. This could include award letters or benefit statements."
      },
      "employerName": "Employer name",
      "enterName": "Enter name",
      "enterTypeOfWork": "Enter type of work",
      "grossMonthlyIncome": "Monthly gross income (before taxes)",
      "payFrequency": "Pay frequency",
      "selfEmploymentNetMonthlyIncome": "Estimated monthly NET income after expenses",
      "title": "Select Income Type",
      "typeOfWork": "Type of work",
      "unemploymentCompensationStatus": "Do you receive unemployment compensation?",
      "workWeekHours": "Hours per week"
    },
    "monthlyIncome": "{{monthlyIncome}} / month",
    "title": "Work & Income"
  },
  "applicationsListScreen": {
    "applicationDate": "MM/DD/YYYY [at] h:mm A",
    "inProgress": "In Progress",
    "noApplications": "You don't have any applications yet.",
    "submitted": "Submitted",
    "title": "{{applicationType}} Applications"
  },
  "authScreen": {
    "appleSignInFailed": "We couldn't sign you in with Apple. Please try again or use a different sign-in option.",
    "checkYourEmail": "Check your email",
    "checkYourSpam": "Didn't get it? Check your spam folder or wait a few minutes before trying again.",
    "continueWithApple": "Continue with Apple",
    "continueWithGoogle": "Continue with Google",
    "dataSecured": "Your data is secure with us. HIPAA & SOC 2 Compliant.",
    "emailInput": "Email Address",
    "googleSignInFailed": "We couldn't sign you in with Google. Please try again or use a different sign-in option.",
    "identifierInput": "Email or username",
    "invalidIdentifier": "Enter a valid email address or username.",
    "subtitle": "Enter your email or username to continue.",
    "title": "Sign in or Create an Account",
    "weSentALink": "We sent a secure link to <bold>{{email}}</bold>. Click the link to continue.",
    "youAgree": "By continuing, you agree to our <underline><colorEmphasis>Terms of Service</colorEmphasis></underline> and <privacyLink><colorEmphasis>Privacy Policy</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "No thanks",
    "recommendedBadge": "Recommended",
    "yesButton": "Yes, connect me"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Continue with Medicaid only",
    "continueWithoutAgentButton": "Continue without an agent",
    "declineCard": {
      "applyLink": "Apply to {{program}}",
      "fallbackWithMedicaid": "You can still continue your Medicaid application here. Pointcare can handle your Medicaid application without an agent.",
      "fallbackWithoutMedicaid": "You can still continue your application here. Finishing now means Pointcare can support you when your coverage needs change.",
      "selfEnrollmentWarning": "Without an agent, you'll need to enroll in {{programs}} on your own.",
      "title": "Select “Yes, connect me” to get the most from Pointcare"
    },
    "subtitle": "We'll connect you when it's time to enroll, and only share what's needed to help.",
    "subtitleWithIndividual": "We'll connect you when it's time to enroll, and only share what's needed to help. If you're applying for Medicare, this agent will be {{brokerName}}.",
    "subtitleWithIndividualLicense": "We'll connect you when it's time to enroll, and only share what's needed to help. If you're applying for Medicare, this agent will be {{brokerName}} (License #: {{licenseNumber}}).",
    "subtitleWithOrganization": "We'll connect you when it's time to enroll, and only share what's needed to help. If you're applying for Medicare, this agent will be from {{brokerName}}.",
    "subtitleWithOrganizationLicense": "We'll connect you when it's time to enroll, and only share what's needed to help. If you're applying for Medicare, this agent will be from {{brokerName}} (License #: {{licenseNumber}}).",
    "title": "Connect with a licensed insurance agent to explore Medicare and/or ACA Marketplace options and get help finishing enrollment"
  },
  "camera": {
    "grantPermission": "Grant Permission",
    "permissionDescription": "To take photos of your documents, please allow camera access in your phone's settings.",
    "permissionRequired": "We need access to your camera.",
    "photoCount": "{{count}} photo(s) captured",
    "tapToCapture": "Tap the button to take a photo"
  },
  "cesSurvey": {
    "feedbackLabel": "What made this hard?",
    "feedbackPlaceholder": "Tell us more",
    "optionalLabel": "Optional",
    "questions": {
      "consentFormSigned": "How easy was it to understand what you were signing?",
      "householdMemberAdded": "How easy was it to add a household member?",
      "incomeAdded": "How easy was it to add income?"
    },
    "scoreEasy": "Easy",
    "scoreHard": "Hard",
    "scoreOk": "OK",
    "scoreVeryEasy": "Very easy",
    "scoreVeryHard": "Very hard",
    "thanksDescription": "Your feedback helps us improve.",
    "thanksTitle": "Thanks!"
  },
  "consentDocuments": {
    "addSignature": "Add Signature",
    "description": "Sign below so we can support you.",
    "documentTitle": "Authorization to Release (PDF)",
    "grant1": "Monitor your coverage and catch issues early",
    "grant2": "Respond to requests on your behalf - no lost mail or scrambles",
    "grant3": "Submit applications and renewals, and follow up so you never miss a deadline",
    "grant4": "Contact you for marketing purposes through regular or automated phone calls, voice messages, and texts",
    "grantHealthPlanSelection": "Apply your choice of health plan and doctor (when available) to your coverage",
    "grantSubtitle": "Here's what that includes:",
    "healthPlanAvailabilityError": "We couldn't check available health plans. Please try again before signing.",
    "signatureCountsAsInitials": "Your signature also counts as your initials on the form where applicable.",
    "title": "Managing Your Family's Coverage",
    "viewDocument": "View Document"
  },
  "coverage": {
    "code": "Code:",
    "coverageStatus": "Coverage Status",
    "inProgress": "In Progress",
    "isCovered": "{{name}} is covered by {{programs}}.",
    "lastCheck": "Last check",
    "lastCheckDateFormat": "MM/DD/YYYY",
    "lastCheckWithDate": "Last check {{date}}",
    "noMatchingRecord": "We couldn't find your coverage. Please double-check the details you entered and try again.",
    "planName": "Plan name",
    "primaryCareProvider": "Primary care provider",
    "programCoverage": "{{program}} Coverage",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> and <bold>Medicaid</bold>"
    },
    "serviceTypes": "Service types",
    "status": {
      "checking": "Checking coverage...",
      "checkingShort": "Checking...",
      "covered": "Covered",
      "coveredBy": "Covered by {{ programs }}",
      "notCovered": "Not covered",
      "unknown": "Coverage unknown",
      "unknownShort": "Unknown"
    },
    "updateProfileInformation": "Update Profile Information"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Create a password",
    "passwordRequirement": "Use at least 10 characters.",
    "subtitle": "Secure your new account with a strong password to continue.",
    "title": "Create a password"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Create a password",
    "subtitle": "Secure your new account with a strong password to continue.",
    "title": "Create a password"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "DD",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "YYYY"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Use GROSS income (before taxes) for most income sources. If you're self-employed, use your net income (after business expenses).",
    "description2": "This includes estimated income for all household members:",
    "hideBreakdown": "Hide breakdown",
    "householdIncomeCalculator": {
      "annualDescription": "Enter each person's estimated annual income to calculate your total",
      "biWeeklyDescription": "Enter each person's estimated bi-weekly income to calculate your total",
      "monthlyDescription": "Enter each person's estimated monthly income to calculate your total",
      "period": {
        "annual": "year",
        "biWeekly": "2 weeks",
        "monthly": "month"
      },
      "title": "Calculate your income",
      "totalIncomeTitle": "Total household income:",
      "totalIncomeValue": "{{total}} /{{period}}",
      "useRange": "Use {{label}}"
    },
    "incomePeriod": {
      "annual": "Annual",
      "biWeekly": "Bi-weekly",
      "monthly": "Monthly"
    },
    "incomeRange": {
      "0-1800": "$0 - $1,800",
      "0-3700": "$0 - $3,700",
      "0-44400": "$0 - $44,400",
      "1600-2600": "$1,600 - $2,600",
      "2500-3000": "$2,500 - $3,000",
      "3000-3300": "$3,000 - $3,300",
      "3300+": "$3,300 or above",
      "3500-5600": "$3,500 - $5,600",
      "43000-67000": "$43,000 - $67,000",
      "5500-6500": "$5,500 - $6,500",
      "6500-7000": "$6,500 - $7,000",
      "66000-78000": "$66,000 - $78,000",
      "7000+": "$7,000 or above",
      "78000-83000": "$78,000 - $83,000",
      "83000+": "$83,000 or above"
    },
    "showBreakdown": "Need help calculating? Show breakdown",
    "title": "What is your approximate household income?",
    "updateError": "We couldn't save your income. Please try again."
  },
  "eligibilityHouseholdMembers": {
    "title": "Your household",
    "you": "You"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "They must <bold>live with you</bold> for <bold>more than half the year</bold> and you must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills). This includes non-blood relatives.",
    "formDescription": "Add any children, stepchildren, grandchildren, or foster children under 19 who live with you and you financially support.",
    "formTitle": "Tell us about the children you support",
    "supporterDescription": "They must <bold>live with {{supporterFirstName}}</bold> for <bold>more than half the year</bold> and {{supporterFirstName}} must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills). This includes non-blood relatives.",
    "supporterFormDescription": "Add any children, stepchildren, grandchildren, or foster children under 19 who live with {{supporterFirstName}}.",
    "supporterFormTitle": "Tell us about {{supporterFirstName}} children",
    "supporterTitle": "Does {{supporterFirstName}} live with and care for any children under the age of 19?",
    "title": "Do you live with and care for any children under the age of 19?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "This helps us understand your household and determine which programs you may be eligible for.",
    "formDescription": "We need some basic information about your spouse or partner to help determine your eligibility.",
    "formTitle": "Tell us about your spouse or partner",
    "supporterFormDescription": "We need some basic information about {{supporterFirstName}} spouse or partner.",
    "supporterFormTitle": "Tell us about {{supporterFirstName}} spouse or partner",
    "supporterTitle": "What is {{supporterFirstName}} marital status?",
    "title": "What is your marital status?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "You must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills).",
    "formDescription": "Add any full-time students aged 18–21 for whom you are the parent or legal guardian and financially support.",
    "formTitle": "Tell us about the student you support",
    "supporterDescription": "{{supporterFirstName}} must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills).",
    "supporterFormDescription": "Add any full-time students aged 18–21 for whom {{supporterFirstName}} is the parent or legal guardian and provides financial support.",
    "supporterFormTitle": "Tell us about the student {{supporterFirstName}} supports",
    "supporterTitle": "Is {{supporterFirstName}} the parent or legal guardian of a full-time student aged 18 - 21 who they financially support?",
    "title": "Are you the parent or legal guardian of a full-time student aged 18 - 21 who you financially support?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "This includes food, housing, schooling, and medical bills.",
    "errors": {
      "updateFailed": "We couldn't save those changes. Please try again."
    },
    "formDescription": "Add the individual who provides more than half of your annual financial support, such as a parent, guardian, or relative.",
    "formTitle": "Tell us about the person who supports you",
    "options": {
      "disabled": "Yes, I’m disabled and live year-round with the person that supports me.",
      "fullTimeStudent": "Yes, I am a full-time student and my parent or legal guardian supports me.",
      "personSupportsMe": "Yes, I live more than half the year with the person that supports me.",
      "relativeSupportsMe": "Yes, I live more than half the year with a relative that supports me."
    },
    "title": "Does someone provide more than half of your annual financial support?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Add details",
    "conditions": {
      "blind": "Someone is blind",
      "breastCancer": "Someone has breast cancer",
      "cervicalCancer": "Someone has cervical cancer",
      "disabled": "Someone is disabled (SSDI)",
      "fosterCare": "Someone was in foster care when they turned 18",
      "pregnant": "Someone is pregnant"
    },
    "description": "Please select any situations that apply to household members.",
    "errors": {
      "allUpdatesFailed": "We couldn't save those changes. Please try again."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Estimated due date",
      "numberOfBabies": "Number of babies expected",
      "title": "Pregnancy Details"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} baby • Due {{date}}",
      "babiesWithCount_other": "{{count}} babies • Due {{date}}"
    },
    "title": "Special Cases in Your Household"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "This can be anyone — child, sibling, grandparent, or non-blood relative — of any age. You must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills).",
    "formDescription": "Add any disabled individuals who live with you year-round and whom you financially support. This can include children, siblings, grandparents, or non-blood relatives.",
    "formTitle": "Tell us about the disabled individual you support",
    "supporterDescription": "This can be anyone — child, sibling, grandparent, or non-blood relative — of any age. {{supporterFirstName}} must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills).",
    "supporterFormDescription": "Add any disabled individuals who live with {{supporterFirstName}} year-round and for whom {{supporterFirstName}} provides financial support. This can include children, siblings, grandparents, or non-blood relatives.",
    "supporterFormTitle": "Tell us about the person {{supporterFirstName}} supports",
    "supporterTitle": "Does {{supporterFirstName}} financially support a disabled individual who lives with them year-round?",
    "title": "Do you financially support a disabled individual who lives with you year-round?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "They must <bold>live with you</bold> for <bold>more than half the year</bold> and you must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills). This includes immediate and extended relatives, step-family, and in-laws.",
    "formDescription": "Add any immediate or extended relatives, step-family, or in-laws who live with you and whom you financially support.",
    "formTitle": "Tell us about the relatives you support",
    "supporterDescription": "They must <bold>live with {{supporterFirstName}}</bold> for <bold>more than half the year</bold> and {{supporterFirstName}} must <bold>provide more than half</bold> of their <bold>annual expenses</bold> (food, housing, schooling, and medical bills). This includes immediate and extended relatives, step-family, and in-laws.",
    "supporterFormDescription": "Add any immediate or extended relatives, step-family, or in-laws who live with {{supporterFirstName}} for most of the year and for whom {{supporterFirstName}} provides financial support.",
    "supporterFormTitle": "Tell us about the relatives {{supporterFirstName}} supports",
    "supporterTitle": "Does {{supporterFirstName}} financially support any other relatives who live with them?",
    "title": "Do you financially support any other relatives who live with you?"
  },
  "homeScreen": {
    "addMember": "Add Member",
    "applicationSubmittedCard_multiple": "You submitted <programs /> applications for {{memberNames}}. We’ll review it and follow up if we need anything.",
    "applicationSubmittedCard_single": "You submitted a <programs /> application for {{memberNames}}. We’ll review it and follow up if we need anything.",
    "applicationSubmittedCard_singleMarketplace": "You submitted an <programs /> application for {{memberNames}}. We’ll review it and follow up if we need anything.",
    "checkEligibility": "Check Household Eligibility",
    "checkEligibilityCompact": "Check Eligibility",
    "devScenarioActive": "Simulated scenario active — the dashboard is showing test data.",
    "devScenarioReset": "Reset",
    "eligibilityCardCompactNotStarted": "See which programs you may qualify for",
    "eligibilityCardCompactStarted": "Continue to see which programs you may qualify for",
    "eligibilityCardNotStarted": "Start a quick step-by-step check to see which programs your household might qualify for",
    "eligibilityCardStarted": "Continue your eligibility check to see which programs your household might qualify for",
    "household": "Household",
    "logout": "Logout",
    "nextSteps": "Next steps",
    "recheckEligibility": "Recheck Eligibility"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Applicant Documents",
    "checkCoverage": "Check Coverage",
    "deleteButton": "Remove {{memberFullName}} from household",
    "deleteDialog": {
      "description": "This will permanently remove {{memberFullName}} from your household. All of their information and uploaded documents will be deleted and cannot be recovered.\nThis action cannot be undone.",
      "title": "Remove Household Member"
    },
    "deleteToast": {
      "error": "We couldn't remove that household member. Please try again.",
      "success": "Household member deleted successfully"
    },
    "profileInformation": "Profile Information"
  },
  "landingScreen": {
    "goToAuth": "Go to Auth Screen"
  },
  "languageSelectorModal": {
    "title": "Select Language"
  },
  "languages": {
    "arabicDescription": "Arabic",
    "chineseSimplifiedDescription": "Chinese Simplified",
    "englishDescription": "English",
    "haitianCreoleDescription": "Haitian Creole",
    "russianDescription": "Russian",
    "spanishDescription": "Spanish",
    "tagalogDescription": "Tagalog",
    "vietnameseDescription": "Vietnamese"
  },
  "memberFormSubmission": {
    "error": "We couldn't save those changes. Please try again.",
    "success": "Household member updated successfully"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Phone Number",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "We'll send you a verification code.",
    "subtitle": "We'll use this to keep your account secure.",
    "title": "What's your phone number?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Get a new code",
    "subtitle": "Please enter the 6-digit code we sent to\n<bold>{{phoneNumber}}</bold>",
    "title": "We sent you a code",
    "verificationCodeLabel": "Verification Code"
  },
  "notFound": {
    "cta": "Go Home",
    "description": "The page you're looking for isn't here anymore.",
    "title": "Page not found."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "What did you like most about Pointcare? (optional)",
    "highFeedbackPlaceholder": "Tell us what stood out",
    "lowFeedbackLabel": "What could we do better? (optional)",
    "lowFeedbackPlaceholder": "Tell us what went wrong...",
    "mediumFeedbackLabel": "What could have made this a 10 for you? (optional)",
    "mediumFeedbackPlaceholder": "What would've made it better...",
    "scaleHighLabel": "→ Extremely likely",
    "scaleLowLabel": "→ Not likely at all",
    "submitButton": "Submit feedback",
    "subtitle": "Your answers are never shared with the programs you applied to.",
    "success": "Feedback submitted successfully.",
    "testimonialLabel": "May we share your feedback on our website to help more people find coverage? We'll only use your first name.",
    "title": "How likely are you to recommend Pointcare to a friend or family member?"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare helps 1.8M+ patients across the U.S. find and keep their health coverage.",
      "firstItem": "Find out who qualifies in 5 min",
      "firstItem_AGING_INTO_MEDICARE": "Find the right Medicare coverage",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Stay informed about timelines",
      "firstItem_LAPSE": "Find out who qualifies in 5 min",
      "firstItem_QR_CODE": "Find out who qualifies in 5 min",
      "firstItem_RECURRING_WORK_REQUIREMENT": "Never miss an important deadline",
      "firstItem_REDETERMINATION": "Never miss an important deadline",
      "firstItem_SELF_PAY_CONVERSION": "Find out who qualifies in 5 min",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "Never miss an important deadline",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Check everyone's benefits in 5 min",
      "freeToUse": "Free help - no hidden fees",
      "infoIsPrivate": "Any info shared stays private",
      "title": "{{clinicName}} has partnered with Pointcare to support your family",
      "titleNoClinic": "Pointcare is here to support your family"
    },
    "buttons": {
      "createMyProfile": "Create My Profile",
      "getStarted": "Get Started"
    },
    "concerns": {
      "description": "Choose the option that matters most to you — we'll show you how we can help.",
      "description_SERVICE_INTRODUCTION_medicare": "Choose the option that best describes this coverage.",
      "title": "What frustrates you most about getting coverage for your family?",
      "title_SERVICE_INTRODUCTION_medicare": "What Medicare coverage does your family have?"
    },
    "figuringOutWhenToRenew": {
      "option": "Figuring out when to renew",
      "subtext": "We’ll track renewal dates for everyone and remind you before it's too late."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Figuring out when to submit requirements",
      "subtext": "We’ll track work requirement dates for everyone and remind you before it's too late."
    },
    "imNotSure": {
      "option": "I’m not sure",
      "subtext": "We’ll make sure everyone's plan still works for them."
    },
    "intro": {
      "description": "Many people pay nothing. Others pay as little as $20–30 a month. We'll ask a few simple questions to find the best option for everyone.",
      "description_AGING_INTO_MEDICARE": "You're probably getting a lot of offers right now. As your family's healthcare provider, we'll help find the right plan.",
      "description_AGING_INTO_MEDICARE_awareness": "You're probably getting a lot of offers right now. As your family's healthcare provider, we'll help find the right plan.",
      "description_LAPSE": "7 out of 10 people may re-qualify for free or low-cost coverage. Whether it's re-enrolling in Medicaid or finding another option, we'll help every step of the way.",
      "description_QR_CODE": "Many people pay nothing. Others pay as little as $20–30 a month. We'll ask a few simple questions to find the best option for everyone.",
      "description_RECURRING_WORK_REQUIREMENT": "A new law requires proof of income. We’ll check if everyone impacted is on track or exempt from these requirements and support you from there.",
      "description_REDETERMINATION": "You’ll need to confirm or update your household’s information to keep their coverage. We’ll help you every step of the way.",
      "description_SELF_PAY_CONVERSION": "Many people pay nothing. Others pay as little as $20–30 a month. We'll ask a few simple questions to find the best option for everyone.",
      "description_SERVICE_INTRODUCTION_medicaid": "We'll keep an eye on everyone's coverage, help with renewals, and guide you through anything that comes up - for free.",
      "description_SERVICE_INTRODUCTION_medicare": "We’ll help you understand everyone's coverage, find extra benefits, and make sure you don’t miss anything.",
      "title": "Getting health coverage doesn't have to be hard. Your family may qualify for <colorEmphasis>free or low-cost plans</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "It looks like someone in your family has been eligible for Medicare for <colorEmphasis>{{count}} months</colorEmphasis>. We're here to help.",
      "title_AGING_INTO_MEDICARE_awareness_one": "It looks like someone in your family is eligible for Medicare <colorEmphasis>in {{monthsToTurning65}} month</colorEmphasis>. We're here to help.",
      "title_AGING_INTO_MEDICARE_awareness_other": "It looks like someone in your family is eligible for Medicare <colorEmphasis>in {{monthsToTurning65}} months</colorEmphasis>. We're here to help.",
      "title_AGING_INTO_MEDICARE_one": "It looks like someone in your family has been eligible for Medicare for <colorEmphasis>{{count}} month</colorEmphasis>. We're here to help.",
      "title_AGING_INTO_MEDICARE_other": "It looks like someone in your family has been eligible for Medicare for <colorEmphasis>{{count}} months</colorEmphasis>. We're here to help.",
      "title_AGING_INTO_MEDICARE_zero": "It looks like someone in your family has become eligible for Medicare <colorEmphasis>starting this month</colorEmphasis>. We're here to help.",
      "title_LAPSE": "It looks like someone in your family lost {{payerName}} coverage on <colorEmphasis>{{lapseDate}}</colorEmphasis>. We're here to help them regain coverage.",
      "title_QR_CODE": "Your family may qualify for <colorEmphasis>free or low-cost health coverage</colorEmphasis>. Let's find out.",
      "title_RECURRING_WORK_REQUIREMENT_one": "It looks like someone in your family has a {{payerName}} work requirement due <colorEmphasis>in {{count}} month</colorEmphasis>. Let’s keep them covered.",
      "title_RECURRING_WORK_REQUIREMENT_other": "It looks like someone in your family has a {{payerName}} work requirement due <colorEmphasis>in {{count}} months</colorEmphasis>. Let’s keep them covered.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "It looks like someone in your family has a {{payerName}} work requirement due <colorEmphasis>this month</colorEmphasis>. Let’s keep them covered.",
      "title_REDETERMINATION_one": "It looks like someone in your family has a {{payerName}} renewal due <colorEmphasis>in {{count}} month</colorEmphasis>. Let’s keep them covered.",
      "title_REDETERMINATION_other": "It looks like someone in your family has a {{payerName}} renewal due <colorEmphasis>in {{count}} months</colorEmphasis>. Let’s keep them covered.",
      "title_REDETERMINATION_zero": "It looks like someone in your family has a {{payerName}} renewal due <colorEmphasis>this month</colorEmphasis>. Let’s keep them covered.",
      "title_SERVICE_INTRODUCTION_medicaid": "We’re here to help your family <colorEmphasis>stay covered on {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "Is your family <colorEmphasis>getting the most from {{payerName}}?</colorEmphasis> We’re here to help."
    },
    "keepingMyCurrentDoctors": {
      "option": "Keeping current doctors",
      "subtext": "We'll help find a plan that includes the doctors your family already sees."
    },
    "meetingRequirements": {
      "option": "Meeting requirements",
      "subtext": "We’ll support everyone when it comes to meeting and submitting work requirements."
    },
    "missingEnrolmentDeadline": {
      "option": "Missing enrollment deadlines",
      "subtext": "We'll make sure you know when to enroll to avoid any late penalties."
    },
    "nextSteps": {
      "step1Description": "Tell us about yourself",
      "step1Duration": "2 min",
      "step1Title": "Create Profile",
      "step2Description": "Coverage your family qualifies for",
      "step2Description_AGING_INTO_MEDICARE": "Review current status",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Review current status",
      "step2Description_LAPSE": "Coverage your family qualifies for",
      "step2Description_QR_CODE": "Coverage your family qualifies for",
      "step2Description_RECURRING_WORK_REQUIREMENT": "We’ll check if everyone impacted is exempt or on track",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "We’ll check if everyone impacted is exempt or on track",
      "step2Description_REDETERMINATION": "Our call team will reach out",
      "step2Description_REDETERMINATION_awareness": "Including basic contact information",
      "step2Description_SELF_PAY_CONVERSION": "Coverage your family qualifies for",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Review current status",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Review current status",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Review current status",
      "step2Duration": "5 min",
      "step2Duration_AGING_INTO_MEDICARE": "2 min",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 min",
      "step2Duration_LAPSE": "5 min",
      "step2Duration_QR_CODE": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 min",
      "step2Duration_REDETERMINATION": "2 min",
      "step2Duration_SELF_PAY_CONVERSION": "5 min",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 min",
      "step2Title": "Find Your Options",
      "step2Title_AGING_INTO_MEDICARE": "Check Coverage",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Check Coverage",
      "step2Title_LAPSE": "Find Your Options",
      "step2Title_QR_CODE": "Find Your Options",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Check Requirements",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Check Requirements",
      "step2Title_REDETERMINATION": "Request Renewal Support",
      "step2Title_REDETERMINATION_awareness": "Add Household Information",
      "step2Title_SELF_PAY_CONVERSION": "Find Your Options",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Check Coverage",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Check Coverage",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Check Coverage",
      "step3Description": "We’ll take care of the rest!",
      "step3Description_AGING_INTO_MEDICARE": "We’ll take care of the rest!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "We’ll keep you updated and ready",
      "step3Description_LAPSE": "We’ll take care of the rest!",
      "step3Description_QR_CODE": "We’ll take care of the rest!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "We’ll walk you through this",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "We’ll keep you updated and support your family to meet requirements",
      "step3Description_REDETERMINATION": "We'll walk you through this",
      "step3Description_REDETERMINATION_awareness": "We’ll keep you updated and ready",
      "step3Description_SELF_PAY_CONVERSION": "We’ll take care of the rest!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "We’ll alert you ahead of time",
      "step3Description_SERVICE_INTRODUCTION_medicare": "See what’s included in everyone's plan",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Expand benefits",
      "step3Duration": "15 min",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 min",
      "step3Title": "Submit Application",
      "step3Title_AGING_INTO_MEDICARE": "Submit for Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Ready for Medicare",
      "step3Title_LAPSE": "Submit Application",
      "step3Title_QR_CODE": "Submit Application",
      "step3Title_RECURRING_WORK_REQUIREMENT": "Submit Requirements",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Stay Ahead of Requirements",
      "step3Title_REDETERMINATION": "Submit Renewal",
      "step3Title_REDETERMINATION_awareness": "Stay Ahead of Renewal",
      "step3Title_SELF_PAY_CONVERSION": "Submit Application",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "Never Miss a Deadline",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Review Your Benefits",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Explore Medicare Options",
      "title": "Ready to Get Your Family Covered?",
      "title_RECURRING_WORK_REQUIREMENT": "Let’s Keep Your Family Covered",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Let’s Keep Your Family Covered",
      "title_REDETERMINATION": "Let’s Keep Your Family Covered",
      "title_REDETERMINATION_awareness": "Let’s Keep Your Family Covered",
      "title_SERVICE_INTRODUCTION_medicaid": "Let’s Keep Your Family Covered",
      "title_SERVICE_INTRODUCTION_medicare": "Let’s Keep Your Family Covered",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Let’s Keep Your Family Covered"
    },
    "notKnowingHowToGetCovered": {
      "option": "Not knowing how to get covered",
      "subtext": "We'll walk you through exactly what you need to do to get everyone covered."
    },
    "notKnowingImCovered": {
      "option": "Not knowing who is covered",
      "subtext": "We can check whether everyone has coverage and help you get it if you don’t.",
      "subtext_RECURRING_WORK_REQUIREMENT": "We'll check everyone's coverage and help you get it if you need it.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "We'll check everyone's coverage and help you get it if you need it.",
      "subtext_REDETERMINATION": "We'll check everyone's coverage and help you get it if you need it.",
      "subtext_REDETERMINATION_awareness": "We'll check everyone's coverage and help you get it if you need it.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "We'll check everyone's coverage and help you get it if you need it."
    },
    "paperwork": {
      "option": "Too much or confusing paperwork",
      "subtext": "We’ll handle all the paperwork for everyone - from coverage to renewals.",
      "subtext_SERVICE_INTRODUCTION": "We’re working on behalf of your family's provider to find the best option for everyone's health needs."
    },
    "partAB": {
      "option": "Part A & B (Medicare)",
      "subtext": "We’ll find the best option for everyone, whether it’s their current plan or Medicare Advantage (Part C)."
    },
    "partABD": {
      "option": "Part A, B, & D (Medicare + Drug)",
      "subtext": "We’ll find the best option for everyone, whether it’s their current plan or Medicare Advantage (Part C)."
    },
    "partC": {
      "option": "Part C (Medicare Advantage)",
      "subtext": "We’ll make sure everyone's plan still works for them."
    },
    "payingForDoctor": {
      "option": "Paying for doctor visits & medication",
      "subtext": "We’ll help everyone find coverage that lowers costs for doctor visits and medicine."
    },
    "somethingElse": {
      "option": "Something else",
      "subtext": "We’ll help everyone get coverage and keep it.",
      "subtext_AGING_INTO_MEDICARE": "We'll guide you through getting Medicare - step by step.",
      "subtext_AGING_INTO_MEDICARE_awareness": "We'll guide you through getting Medicare - step by step.",
      "subtext_RECURRING_WORK_REQUIREMENT": "We'll help everyone keep their coverage - no surprises.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "We'll help everyone keep their coverage - no surprises.",
      "subtext_REDETERMINATION": "Skip the confusing paperwork. We’ll help everyone stay covered.",
      "subtext_REDETERMINATION_awareness": "Skip the confusing paperwork. We’ll help everyone stay covered.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Skip the confusing paperwork. We’ll help everyone stay covered.",
      "subtext_SERVICE_INTRODUCTION_medicare": "We’ll make sure everyone's plan still works for them."
    },
    "submittingRenewals": {
      "option": "Submitting renewals",
      "subtext": "We’ll handle renewals for everyone. All it takes is a few simple questions."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Too many Medicare ads and calls",
      "subtext": "We’ll cut through the noise and help find the right plan."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare helps 1.8M+ patients find and keep their health coverage.",
          "firstItem_LAPSE": "See who qualifies in 5 min",
          "infoIsPrivate": "Your information is safe with us",
          "title": "{{clinicName}} works with Pointcare to help your family"
        },
        "concerns": {
          "description_LAPSE": "Pick what matters most and we’ll show you how we can help.",
          "title_LAPSE": "What’s the hardest part about getting coverage for your family?"
        },
        "intro": {
          "description_LAPSE": "Most people re-qualify for free or low-cost coverage. We’ll help every step of the way.",
          "title_LAPSE": "Someone in your family lost {{payerName}} coverage on <colorEmphasis>{{lapseDate}}</colorEmphasis>. We’re here to help them regain coverage."
        },
        "nextSteps": {
          "step2Description_LAPSE": "See what your family qualifies for"
        },
        "paperwork": {
          "option": "Confusing paperwork"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "Forgot your password?",
    "passwordInputLabel": "Password",
    "passwordInputPlaceholder": "Enter your password",
    "resetPasswordInstructions": "We sent a password reset link to <bold>{{email}}</bold>. Open it to create a new password.",
    "subtitle": "Please enter the password for your account to continue.",
    "title": "Enter your password",
    "usernameResetUnavailable": "Username accounts cannot reset a password by email. Call us and we can help."
  },
  "profileInformationScreen": {
    "addressComplement": "Apt, Unit, Building (optional)",
    "checkCoverage": "Check Coverage Test",
    "coverageStatus": "Coverage Status: {{status}}",
    "dateOfBirth": "Date of Birth",
    "email": "Email",
    "firstName": "First Name",
    "homeAddress": "Home Address",
    "lastName": "Last Name",
    "mailingAddress": "Mailing Address",
    "mailingAddressComplement": "Apt, Unit, Building, PO Box (optional)",
    "medicaidCaseNumber": "Medicaid case number (optional)",
    "medicaidSubscriberId": "Medicaid Subscriber ID (optional)",
    "noHomeAddress": "No Home Address",
    "noMailingAddress": "No Mailing Address",
    "phoneNumber": "Phone Number",
    "socialSecurityNumber": "Social Security Number",
    "useDifferentMailingAddress": "Use a different mailing address"
  },
  "recheckEligibilityScreen": {
    "button": "Recheck Eligibility",
    "title": "Before rechecking eligibility, make sure your household members are up to date."
  },
  "redeterminationScreen": {
    "addressInformation": "Update Address Information",
    "alreadyMailedForm": "Already mailed a form or plan to soon",
    "caseNumberDescription": "We'll use your case number to submit your renewal quicker!\n\nCheck for this in your renewal form or other mail from your state agency regarding your coverage.",
    "caseNumberDescription_PENDING_FORM": "We'll use your case number to submit your renewal quicker!\n\nCheck for this in mail from your state agency regarding your coverage.",
    "caseNumberLabel": "Case Number",
    "caseNumberPlaceholder": "Enter case number",
    "caseNumberTitle": "Let's Add Your Case Number (Optional)",
    "description": "Select the best option",
    "haventReceivedForm": "Haven't received a form yet",
    "receivedForm": "Received a form and need help completing it",
    "returnToDashboard": "Return to Dashboard",
    "reviewAddress": "Please review and confirm home and mailing addresses for all household members. This ensures the renewal form reaches the right address.",
    "successDescription": "Your renewal is taken care of. We'll reach out if anything changes.",
    "successDescription_CALL_BACK": "Our team will reach out in 1-2 business days to finish your renewal.",
    "successDescription_PENDING_FORM": "The renewal form should arrive at the address on file. Keep an eye out for mail, email, and texts. We'll make sure to follow up before the deadline.",
    "successTitle": "You're All Set!",
    "successTitle_CALL_BACK": "We'll call you soon.",
    "successTitle_PENDING_FORM": "You're All Set!",
    "title": "Someone in your household's renewal is due {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} Medicaid renewals are waiting for a call — due {{dates}}. Keep an eye on your phone.",
    "cardAggregated_NOT_STARTED": "{{total}} Medicaid renewals to start.",
    "cardAggregated_PENDING_FORM": "{{total}} Medicaid renewal forms arriving soon. Watch mail, email, and texts.",
    "cardCompact_PENDING_FORM": "Renewal form arriving soon — due {{date}}",
    "card_CALL_BACK": "Someone in your household has a Medicaid renewal waiting for a call — due {{date}}. Keep an eye on your phone.",
    "card_NOT_STARTED": "Someone in your household has a Medicaid renewal due {{date}}.",
    "card_PENDING_FORM": "Someone in your household has a Medicaid renewal form arriving soon — due {{date}}. Watch mail, email, and texts.",
    "due": "Due {{date}}",
    "medicaidRenewals": "Medicaid Renewals",
    "noRenewals": "No renewals yet.",
    "startRenewal": "Start Renewal",
    "status": "Call Back",
    "status_CALL_BACK": "Call requested",
    "status_COMPLETED": "Completed",
    "status_NOT_STARTED": "Not Started",
    "status_PENDING_FORM": "Waiting for form",
    "title": "Renewals",
    "updateStatus": "Update Status"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare can look up your current Medicaid coverage using the information you provide below.",
    "title": "Let's Check Your Coverage"
  },
  "registrationProfileScreen": {
    "description": "Provide profile details to be used in applications."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Confirm new password",
    "confirmPasswordInputPlaceholder": "Re-enter new password",
    "invalidResetLink": "This password reset link is invalid or has expired. Please request a new one.",
    "passwordInputLabel": "New password",
    "passwordInputPlaceholder": "Enter new password",
    "subtitle": "Choose a strong password you haven't used before.",
    "title": "Create a new password",
    "updatePasswordButton": "Update password"
  },
  "sessionTimedOut": {
    "description": "For your security, we signed you out after a period of inactivity. Please sign in again to continue.",
    "loginAgain": "Log In Again",
    "title": "You've been signed out"
  },
  "sessionTimeout": {
    "countdown": "{{time}} remaining",
    "description": "You're about to be signed out for inactivity. Do you want to stay signed in?",
    "logOutNow": "Log Out Now",
    "secureSession": "Secure Session",
    "stayLoggedIn": "Stay Logged In",
    "title": "Still there?"
  },
  "signatureField": {
    "signaturePrompt": "Draw your signature"
  },
  "someHouseholdMembersNotUpdated": "We couldn't save changes for everyone. Please review each household member to make sure everything's saved.",
  "support": {
    "callUs": "Call Us",
    "callUsAt": "Call us at <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Start",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Upload",
    "cardAction_CONTINUE": "Continue Work Requirements",
    "cardAction_START": "Start Work Requirements",
    "cardAction_UPLOAD_DOCUMENTS": "Upload Documents",
    "cardCompact": "Medicaid Work Requirements due {{date}}",
    "card_CONTINUE": "Someone in your household has Medicaid Work Requirements due {{date}}. Finish checking who's on track or exempt.",
    "card_START": "Someone in your household has Medicaid Work Requirements due {{date}}. Check if you're on track or exempt.",
    "card_UPLOAD_DOCUMENTS": "Someone in your household has Medicaid Work Requirements due {{date}}. Upload documents to stay on track.",
    "caseNumbers": {
      "description": "We'll use these case numbers to submit for your household.",
      "descriptionSingle": "We'll use this case number to submit {{name}}'s work documents.",
      "hint": "Check for these in mail from your state agency regarding your coverage.",
      "hintSingle": "Check for this in mail from the state agency regarding {{name}}'s coverage.",
      "memberLabel": "{{name}}",
      "title": "Let's Add Your Household's Case Numbers (Optional)",
      "titleSingle": "Let's Add {{name}}'s Case Number (Optional)"
    },
    "confirmation": {
      "completedDescription": "Our team will review and reach out if we need anything.",
      "completedTitle": "Congratulations, you completed <label>Work Requirements</label>",
      "description": "Please remember to complete your requirements before your {{date}} renewal.",
      "title": "<label>Work Requirements</label> are in progress",
      "uploadsHint": "You can finish uploads from the Dashboard when more months open."
    },
    "due": "Due <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Select all that apply",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Benefits & coverage",
        "CAREGIVING": "Caregiving",
        "HEALTH_AND_RECOVERY": "Health & recovery",
        "LIFE_SITUATIONS": "Life situations"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "A parent or caregiver of a child age 13 or younger",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "A caregiver of a person with a disability",
        "FOSTER_YOUTH_UNDER_26": "Foster youth or former foster youth under the age of 26",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "In jail or prison, or were released in the last 90 days",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "In a drug or alcohol treatment program",
        "MEDICALLY_FRAIL": "Medically frail",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Already meeting SNAP/TANF work requirements",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "Not enrolled in or eligible for Medicare",
        "PREGNANT_OR_POSTPARTUM": "Pregnant or postpartum (12 months or less)",
        "TRIBAL_MEMBER": "Member of a federally recognized Native American tribe",
        "VETERAN_100_PERCENT_DISABILITY": "Veteran with a total (100%) disability rating"
      },
      "title": "Do any of these exemptions apply?"
    },
    "hours": {
      "communityService": "Community service",
      "description_completed": "Add {{name}}'s completed hours for {{month}}. Leave blank if none.",
      "description_expected": "Add {{name}}'s expected hours for {{month}}. Leave blank if none.",
      "employment": "Employment",
      "employmentHint": "Enter hours and monthly pay. We'll convert pay to hours and count whichever is higher toward the requirement.",
      "hoursPerMonth": "hours / month",
      "jobTraining": "Job training",
      "payPerMonth": "$ / month",
      "school": "School / apprenticeship",
      "title": "Report Hours for {{name}}",
      "totalHours": "Total hours",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Select all that apply, or continue if no one does.",
      "everyone": "Everyone here",
      "title": "Who makes ${{amount}} or more a month?",
      "titleSingle": "Does {{name}} make ${{amount}} or more a month?"
    },
    "medicaidWorkRequirements": "Medicaid Work Requirements",
    "nextSteps": {
      "complete": "{{completed}} of {{total}} complete",
      "description": "Here's what each person needs to submit to keep their coverage.",
      "needsMoreHours": "Needs {{hours}} more hours / month",
      "offrampDescription": "To keep health coverage, {{hours}} hours of approved activities must be completed per month. This can include employment, job training, school, apprenticeship, and/or community service.",
      "opensOn": "Opens {{date}}",
      "proofOfExemption": "Proof of Exemption",
      "proofOfWork": "Proof of Work ({{month}})",
      "reasonHours": "Reported {{hours}} hours / month",
      "reasonIncome": "Earns ${{amount}} or more a month",
      "reportedOf": "Reported {{hours}} of {{required}} hours / month",
      "status_EXEMPT": "Exempt",
      "status_MEETS_REQUIREMENTS": "Meets requirements",
      "title": "<label>Work Requirements</label> Next Steps",
      "volunteerOpportunities": "Volunteer Opportunities"
    },
    "noWorkRequirements": "There are no work requirements for your household.",
    "progress_ACTION_NEEDED": "Action needed",
    "progress_COMPLETED": "Completed",
    "progress_UP_TO_DATE": "Up to date",
    "recheck": "Recheck Work Requirements",
    "sectionTitle": "Work requirements",
    "whatAreDescription": "A new federal law requires certain Medicaid adults to work, train for a job, go to school, or volunteer for {{hours}} hours/month. This only applies to adults ages {{minAge}} to {{maxAge}}.",
    "who": {
      "checkAll": "Check all household members",
      "noEligibleMembers": "No one in your household is between {{minAge}} and {{maxAge}} years old, so no one needs to be checked.",
      "question": "<bold>Who do you want to check? We'll see if they are on track or exempt and support you from there.</bold>",
      "title": "Check Household for <label>Work Requirements</label> Status"
    }
  }
}
